import type { Template } from "@/types";

export const SQ_07_H6_V1: Template[] = [
    {
        id: "sq-07-h6v1-01",
        name: "SQ 01 - H6V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h6_v1_01.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 91, y: 166, width: 276, height: 188, rotation: 0, imageRotation: 0 },
            { id: "2", x: 91, y: 362, width: 276, height: 188, rotation: 0, imageRotation: 0 },
            { id: "3", x: 375, y: 166, width: 251, height: 384, rotation: 0, imageRotation: 0 },
            { id: "4", x: 796, y: 166, width: 276, height: 188, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1080, y: 166, width: 275, height: 188, rotation: 0, imageRotation: 0 },
            { id: "6", x: 796, y: 362, width: 276, height: 188, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1080, y: 362, width: 275, height: 188, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-07-h6v1-02",
        name: "SQ 02 - H6V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h6_v1_02.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 68, y: 73, width: 581, height: 375, rotation: 0, imageRotation: 0 },
            { id: "2", x: 68, y: 456, width: 287, height: 188, rotation: 0, imageRotation: 0 },
            { id: "3", x: 363, y: 456, width: 286, height: 188, rotation: 0, imageRotation: 0 },
            { id: "4", x: 785, y: 73, width: 277, height: 185, rotation: 0, imageRotation: 0 },
            { id: "5", x: 785, y: 266, width: 277, height: 185, rotation: 0, imageRotation: 0 },
            { id: "6", x: 785, y: 459, width: 277, height: 185, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1069, y: 73, width: 297, height: 571, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-07-h6v1-03",
        name: "SQ 03 - H6V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h6_v1_03.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 68, y: 73, width: 581, height: 439, rotation: 0, imageRotation: 0 },
            { id: "2", x: 68, y: 520, width: 189, height: 124, rotation: 0, imageRotation: 0 },
            { id: "3", x: 265, y: 520, width: 188, height: 124, rotation: 0, imageRotation: 0 },
            { id: "4", x: 461, y: 520, width: 188, height: 124, rotation: 0, imageRotation: 0 },
            { id: "5", x: 785, y: 73, width: 581, height: 304, rotation: 0, imageRotation: 0 },
            { id: "6", x: 785, y: 384, width: 399, height: 260, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1192, y: 384, width: 174, height: 260, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-07-h6v1-04",
        name: "SQ 04 - H6V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h6_v1_04.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 98, y: 99, width: 256, height: 168, rotation: 0, imageRotation: 0 },
            { id: "2", x: 98, y: 275, width: 256, height: 168, rotation: 0, imageRotation: 0 },
            { id: "3", x: 98, y: 451, width: 256, height: 167, rotation: 0, imageRotation: 0 },
            { id: "4", x: 362, y: 99, width: 256, height: 168, rotation: 0, imageRotation: 0 },
            { id: "5", x: 362, y: 275, width: 256, height: 168, rotation: 0, imageRotation: 0 },
            { id: "6", x: 362, y: 451, width: 256, height: 167, rotation: 0, imageRotation: 0 },
            { id: "7", x: 898, y: 99, width: 355, height: 519, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-07-h6v1-05",
        name: "SQ 05 - H6V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h6_v1_05.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 70, y: 76, width: 276, height: 183, rotation: 0, imageRotation: 0 },
            { id: "2", x: 70, y: 267, width: 276, height: 183, rotation: 0, imageRotation: 0 },
            { id: "3", x: 70, y: 458, width: 276, height: 183, rotation: 0, imageRotation: 0 },
            { id: "4", x: 353, y: 76, width: 294, height: 565, rotation: 0, imageRotation: 0 },
            { id: "5", x: 787, y: 76, width: 577, height: 371, rotation: 0, imageRotation: 0 },
            { id: "6", x: 787, y: 455, width: 285, height: 186, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1080, y: 455, width: 284, height: 186, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-07-h6v1-06",
        name: "SQ 06 - H6V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h6_v1_06.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 70, y: 76, width: 577, height: 429, rotation: 0, imageRotation: 0 },
            { id: "2", x: 70, y: 513, width: 187, height: 128, rotation: 0, imageRotation: 0 },
            { id: "3", x: 265, y: 513, width: 187, height: 128, rotation: 0, imageRotation: 0 },
            { id: "4", x: 460, y: 513, width: 187, height: 128, rotation: 0, imageRotation: 0 },
            { id: "5", x: 787, y: 141, width: 274, height: 435, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1069, y: 141, width: 295, height: 214, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1069, y: 363, width: 295, height: 213, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "sq-07-h6v1-07",
        name: "SQ 07 - H6V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h6_v1_07.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 70, y: 76, width: 169, height: 107, rotation: 0, imageRotation: 0 },
            { id: "2", x: 70, y: 191, width: 169, height: 107, rotation: 0, imageRotation: 0 },
            { id: "3", x: 70, y: 306, width: 169, height: 107, rotation: 0, imageRotation: 0 },
            { id: "4", x: 70, y: 421, width: 169, height: 106, rotation: 0, imageRotation: 0 },
            { id: "5", x: 70, y: 535, width: 169, height: 106, rotation: 0, imageRotation: 0 },
            { id: "6", x: 247, y: 76, width: 400, height: 565, rotation: 0, imageRotation: 0 },
            { id: "7", x: 787, y: 141, width: 577, height: 435, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "sq-07-h6v1-08",
        name: "SQ 08 - H6V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h6_v1_08.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 61, y: 129, width: 322, height: 226, rotation: 0, imageRotation: 0 },
            { id: "2", x: 61, y: 363, width: 322, height: 225, rotation: 0, imageRotation: 0 },
            { id: "3", x: 391, y: 129, width: 322, height: 226, rotation: 0, imageRotation: 0 },
            { id: "4", x: 391, y: 363, width: 322, height: 225, rotation: 0, imageRotation: 0 },
            { id: "5", x: 721, y: 129, width: 321, height: 459, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1050, y: 129, width: 322, height: 226, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1050, y: 363, width: 322, height: 225, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-07-h6v1-09",
        name: "SQ 09 - H6V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h6_v1_09.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 47, y: 53, width: 406, height: 611, rotation: 0, imageRotation: 0 },
            { id: "2", x: 461, y: 53, width: 304, height: 199, rotation: 0, imageRotation: 0 },
            { id: "3", x: 461, y: 260, width: 304, height: 198, rotation: 0, imageRotation: 0 },
            { id: "4", x: 461, y: 466, width: 304, height: 198, rotation: 0, imageRotation: 0 },
            { id: "5", x: 773, y: 53, width: 614, height: 405, rotation: 0, imageRotation: 0 },
            { id: "6", x: 773, y: 466, width: 303, height: 198, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1084, y: 466, width: 303, height: 198, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-07-h6v1-10",
        name: "SQ 10 - H6V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h6_v1_10.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 47, y: 53, width: 616, height: 404, rotation: 0, imageRotation: 0 },
            { id: "2", x: 47, y: 465, width: 304, height: 199, rotation: 0, imageRotation: 0 },
            { id: "3", x: 359, y: 465, width: 304, height: 199, rotation: 0, imageRotation: 0 },
            { id: "4", x: 671, y: 53, width: 406, height: 611, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1085, y: 53, width: 302, height: 199, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1085, y: 260, width: 302, height: 198, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1085, y: 466, width: 302, height: 198, rotation: 0, imageRotation: 0 }
        ],
    },

];
